import React from 'react'
import withRedux from 'next-redux-wrapper'
import { App, Store } from 'apps/saatchi/trendingartists'
import { storeSetup } from 'lib/pageSetup'
import { PageActions } from 'actions'
import Theme from 'components/Theme'
const title = 'Trending Artists | Saatchi Art'
const description = 'Discover new emerging artists on Saatchi Art.'
const METADATA = {
  title,
  description,
  og: {
    title,
    description,
    type: 'product',
  },
  preloadImages: [],
  robots: true,
  schema: {
    webpage: {
      headline: title,
      description,
    },
  },
}
type Props = {
  cookie: string
  dataLayer: Record<string, any>
}

const TrendingArtists = () => {
  return (
    <Theme>
      <App />
    </Theme>
  )
}

TrendingArtists.getInitialProps = async ({ store, req, query }) => {
  // Client-Side
  if (!req) {
    return {
      metaData: METADATA,
    }
  }

  // SSR Logic
  storeSetup(store, req)
  // Set artistData using PageAction
  const { page } = query
  store.dispatch(PageActions.SET(page))
  const dataLayer = {
    pagetype: 'TrendingArtists',
    subpagetype: 'TrendingArtists',
  }
  // Metadata & Datalayer
  return {
    dataLayer,
    metaData: METADATA,
  }
}

export default withRedux(Store)(TrendingArtists)
